import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

export const Skeleton = React.forwardRef<HTMLDivElement>(
  function FooterSkeleton(_, ref) {
    return <StyledBlock ref={ref} $width="100%" $height="600px" />;
  },
);

const StyledBlock = styled(SkeletonBlock)`
  flex-shrink: 0;
`;
